import { HasName } from "app/common/core/types"
import { toDisplayDate } from "app/common/utilities/date"
import { LocaleD } from "db"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import { tw } from "twind"

type ArticleAuthorAndDateProps = {
  authors: HasName[]
  date: Date
  locale: LocaleD
}

export const ArticleAuthorAndDate = ({ authors, date, locale }: ArticleAuthorAndDateProps) => {
  return (
    <div>
      {pipe(
        authors,
        array.map((author) => (
          <div className={tw(`font-semibold text-sm`)} key={author.name}>
            {author.name}
          </div>
        ))
      )}
      <div className={tw(`font-semibold text-sm`)}>{toDisplayDate(date, locale)}</div>
    </div>
  )
}
